module.exports = __webpack_public_path__ + "static/media/safari.fb86e837.svg";